export default __webpack_public_path__ + "static/media/click3.e6a6efe3.wav";